import React from 'react';

import classNames from 'classnames';
import PropTypes from 'prop-types';
import {
    Input,
    TextField as TextFieldBase,
} from 'react-aria-components';

import { combineClasses } from 'wanderu-css';

// eslint-disable-next-line css-modules/no-unused-class
import styles from './TextField.scss';

const TextField = ({
    classes: classesProp = {},
    defaultValue = '',
    Icon,
    name,
    onChange,
    onClick,
    onFocus,
    onKeyDown,
    placeholder,
    value,
})=> {
    const classes = combineClasses(styles, classesProp);

    return (
        <TextFieldBase
            className={classes.inputContainer}
            defaultValue={defaultValue}
            onChange={onChange}
            onFocus={onFocus}
            onKeyDown={onKeyDown}
            value={value}
        >
            {Icon && <Icon className={classes.icon} />}
            <Input
                className={classNames(classes.input, { [styles.withIcon]: !!Icon })}
                data-id={name}
                onClick={onClick}
                placeholder={placeholder}
            />
        </TextFieldBase>
    );
};

TextField.propTypes = {
    classes: PropTypes.object,
    defaultValue: PropTypes.string,
    Icon: PropTypes.elementType,
    name: PropTypes.string,
    onChange: PropTypes.func,
    onClick: PropTypes.func,
    onFocus: PropTypes.func,
    onKeyDown: PropTypes.func,
    placeholder: PropTypes.string,
    value: PropTypes.string,
};

export default TextField;
